import { MutationTree } from 'vuex'

import { MonitorState } from '@/types/store'
import { IMonitor } from '@/types/monitor'

export const mutations: MutationTree<MonitorState> = {
  monitorsLoadStart(state) {
    state.isMonitorsLoading = true
  },
  monitorsLoaded(state, payload: [IMonitor[], number]) {
    state.monitors = payload[0]
    state.total = payload[1]
    state.isMonitorsLoading = false
  },
  setMonitor(state, monitor: IMonitor) {
    state.monitor = monitor
  },
  createMonitor(state, payload: MonitorState['monitor']) {
    state.monitors.push(payload)
  },
}
